exports.ElementCenteredStyle = {
  height: "95vh",
  display: "flex",
  alignItems: "center",
  justifyContent: "center"
};
